import { render } from "./VerticalCardLoader.vue?vue&type=template&id=30e84c66"
import script from "./VerticalCardLoader.vue?vue&type=script&lang=js"
export * from "./VerticalCardLoader.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/zaytoon-sudani-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__